import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class LangProvider {

    static onInit: EventEmitter<any> = new EventEmitter<any>();

    static config: any = {
        // endpoint: 'http://localhost:8000/',
        endpoint: 'https://translate.arsahosting.com/',
        projectUuid: '9ee3f96a-3e6c-4553-adb4-82ea0f4baf14',
        cacheLastLang: true,
        autoInit: false
    };
    static debug: boolean = false;
    // CAUTION: This static (and accessible) property can be null if LangProvider has not at least one instance
    static singleton: LangProvider = null;
    static reloader: {isLoaded: boolean, isInitialized: boolean} = {isLoaded: true, isInitialized: false};

    baseUrl = '/assets/lang/';
    loadedLang = null;
    selectedLang: string = '*\**';
    supportedLangs = {
        'ES': { FullName: 'Español', File: 'es.json' },
        'EN': { FullName: 'English', File: 'en.json' }
    };

    constructor(private _http: HttpClient) {
        if (LangProvider.singleton==null) LangProvider.singleton = this;

        // Unique instance constructor
        if (LangProvider.singleton==this) {
            if (LangProvider.config.autoInit) LangProvider.singleton.loadAcutualLangSync();
            LangProvider.onInit.emit(LangProvider.config);
        }
    }

    public getLangArray(): any[] {
        let arr = [];
        for(let prop in LangProvider.singleton.supportedLangs) {
            arr.push({ Code: prop, FullName: LangProvider.singleton.supportedLangs[prop].FullName });
        }
        return arr;
    }

    public getTranslationSync(value = ''): string {
        if (!LangProvider.singleton.loadedLang) return value;
        let translation = '';
        if (
            LangProvider.singleton.loadedLang &&
            LangProvider.singleton.loadedLang.Meta &&
            LangProvider.singleton.loadedLang.Meta.LangCode &&
            LangProvider.singleton.loadedLang.Meta.LangCode == LangProvider.singleton.selectedLang &&
            LangProvider.singleton.loadedLang.Translations[value]
        ) {
            translation = LangProvider.singleton.loadedLang.Translations[value];
        } else {
            translation = value;
            LangProvider.singleton.requestDefinition(value);
        }


        if (LangProvider.debug) console.log('Getting: '+value, 'Resolved as: '+translation, LangProvider.singleton.loadedLang);
        return translation;
    }

    public async setLanguage(langCode, onSet=null) {
        if (LangProvider.singleton.supportedLangs[langCode]) {
            LangProvider.singleton.selectedLang = langCode;
            await LangProvider.singleton.loadAcutualLangSync();
        } else {
            LangProvider.reloader.isInitialized = true;
        }
        if (onSet) onSet();
    }

    private async loadAcutualLangSync() {
        LangProvider.singleton.loadedLang = await LangProvider.singleton._http
        .get(LangProvider.singleton.resolveLangPath(LangProvider.singleton.selectedLang))
        // .pipe(map(response => response.json()))
        .toPromise().catch(()=>{
            if (LangProvider.debug) console.log('Can\'t load lang, server may be down');
        });

        LangProvider.reloader.isLoaded = false;
        LangProvider.reloader.isInitialized = true;
        await setTimeout(_ => LangProvider.reloader.isLoaded = true, 50);
        if (LangProvider.debug) console.log('Loaded lang: ', LangProvider.singleton.loadedLang);
    }

    private requestDefinition(value=null) {
        if (value) LangProvider.singleton._http.post(
            LangProvider.config.endpoint+'project/'+LangProvider.config.projectUuid+'/request_definition',
            {
                text: value
            }
        ).subscribe(() => {}, () => {
            console.warn('Consider add translation: '+value);
        });
    }

    private resolveLangPath(code): string {
        return LangProvider.config.endpoint+'project/'+LangProvider.config.projectUuid+'/translations/'+code;
    }

}
